import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { handleUnauthorized } from '../../TokenAuth/auth';

const initialState = {
    stats: null,
    status: 'idle',
    loading: false,
    error: null,
};

export const fetchPoojaDashboardStats = createAsyncThunk(
    'poojaDashboard/fetchStats',
    async (_, { rejectWithValue }) => {
        try {
            const token = localStorage.getItem("astroVani-admin-token");

            const response = await fetch(`${process.env.REACT_APP_BASEURL}/admin/pooja/dashboard-stats`, {
                method: "GET",
                headers: {
                    Authorization: token,
                    "Content-Type": "application/json",
                },
            });

            if (response.status === 401) {  
                handleUnauthorized();
                throw new Error("Unauthorized: Please login again");
            }

            if (!response.ok) {
                throw new Error('Failed to fetch pooja dashboard stats');
            }

            const data = await response.json();
            return data;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

const poojaDashboardSlice = createSlice({
    name: 'poojaDashboard',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchPoojaDashboardStats.pending, (state) => {
                state.loading = true;
                state.status = 'loading';
                state.error = null;
            })
            .addCase(fetchPoojaDashboardStats.fulfilled, (state, action) => {
                state.loading = false;
                state.status = 'succeeded';
                state.stats = action.payload.data;
            })
            .addCase(fetchPoojaDashboardStats.rejected, (state, action) => {
                state.loading = false;
                state.status = 'failed';
                state.error = action.payload;
            });
    },
});

export default poojaDashboardSlice.reducer;
